var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 22.6006C3.3051 20.7268 4.76131 17.9715 4.76131 14.8998V11.0667C4.76131 6.83281 8.4499 3.40057 13 3.40057C17.5501 3.40057 21.2387 6.83281 21.2387 11.0667V14.8998C21.2387 17.9715 22.6949 20.7268 25 22.6006M1 22.6006C1 23.9261 6.37258 25 13 25C19.6274 25 25 23.9261 25 22.6006M1 22.6006C1 21.2751 6.37258 20.2 13 20.2C19.6274 20.2 25 21.2751 25 22.6006M15.71 20.9999C15.4946 22.3614 14.3616 23.3999 12.9962 23.3999C11.6473 23.3999 10.5252 22.3864 10.2906 21.0491M10.2904 3.4C10.2904 2.07452 11.5035 1 13 1C14.4966 1 15.7097 2.07452 15.7097 3.4",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/NotificationIcon.ed7ed1f53ef4a0301fb7512c49f00016.svg";
export { ForwardRef as ReactComponent };